import { Button, Form, Popover } from "antd";
import React from "react";
import CreateModal from "../../../core/ui/components/grid/CreateModal";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
import DataGridConfigurationBuilder from "../../../core/ui/components/grid/DataGridConfigurationBuilder";
import { IIndexType } from "../../model/IndexType";
import { IIndexTypeCategory } from "../../model/IndexTypeCategory";
import { TGroupTreePresentationModel } from "../../presenter/model/GroupTreePresentationModel";
import IndexTypeForm from "./IndexTypeForm";
import IndexTypeGroupForm from "./IndexTypeGroupForm";
import TransferListGroupChildModal from "./TransferListGroupChildModal";
import TransferListGroupItemModal from "./TransferListGroupItemModal";

interface IndexTypeGroupGridProps {
  translate: any;
  indexTypeGroups: TGroupTreePresentationModel;
  createIndexTypeGroup: any;
  referenceLoader?: boolean;
  indexTypeCategories: IIndexTypeCategory[];
  createModalVisible: boolean;
  assignItemsModalVisible: boolean;
  onChangeAssignItemsModalVisible: any;
  onChangeCreateModalVisible: any;
  indexTypes: IIndexType[];
  assignItems;
  onChangeAssignGroupsModalVisible;
  onChangeCreateItemModalVisible;
  assignGroups;
  createItemModalVisible;
  assignGroupsModalVisible;
  currentGroupId;
  currentGroupIndexTypes;
  currentGroupChildrenGroupIds;
  createIndexType;
  finishAssigningItems;
  finishAssigningGroups;
  category: IIndexTypeCategory;
  showGroupDetails;
  updateIndexGroupType;
  deleteIndexGroupType;
}
const IndexTypeGroupGrid: React.FC<IndexTypeGroupGridProps> = ({
  translate,
  indexTypeGroups,
  createIndexTypeGroup,
  referenceLoader,
  indexTypeCategories,
  createModalVisible,
  assignItemsModalVisible,
  onChangeAssignItemsModalVisible,
  onChangeCreateModalVisible,
  assignItems,
  onChangeAssignGroupsModalVisible,
  onChangeCreateItemModalVisible,
  assignGroups,
  createItemModalVisible,
  assignGroupsModalVisible,
  currentGroupIndexTypes,
  currentGroupChildrenGroupIds,
  createIndexType,
  finishAssigningItems,
  finishAssigningGroups,
  category,
  indexTypes,
  showGroupDetails,
  updateIndexGroupType,
  deleteIndexGroupType
}) => {
  const builder = DataGridConfigurationBuilder({
    translate,
    resourcePrefix: "editors.index_type_groups"
  });
  const columns = builder.buildColumns(
    "name",
    "description",
    {
      dataKey: "more",
      name: "more",
      sorter: false,
      width: 150,
      render: (record) => {
        return (
          <div style={{ textAlign: "center" }}>
            <Popover
              placement="left"
              content={
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Button
                    style={{ textAlign: "right" }}
                    type={"link"}
                    onClick={(e) => {
                      onChangeAssignItemsModalVisible(true, record.id);
                    }}
                  >
                    {translate("editors.index_type_groups.add_new_types")}
                  </Button>
                  <Button
                    type={"link"}
                    onClick={(e) => {
                      onChangeAssignGroupsModalVisible(true, record.id);
                    }}
                    style={{ marginTop: 12, textAlign: "right" }}
                  >
                    {translate("editors.index_type_groups.add_new_groups")}
                  </Button>
                </div>
              }
              trigger="hover"
            >
              <i className="fas fa-ellipsis-v"></i>
            </Popover>
          </div>
        );
      }
    },
    {
      name: "groupDetails",
      dataKey: "groupDetails",
      sortable: false,
      align: "center",
      render: (record) => (
        <button
          type="button"
          className="ant-btn ant-btn-link ant-btn-sm"
          onClick={() => showGroupDetails(record.id)}
        >
          <span>{translate("editors.index_type_groups.details")}</span>
        </button>
      )
    }
  );
  const [CreateForm] = Form.useForm();
  const [CreateItemForm] = Form.useForm();
  const [UpdateForm] = Form.useForm();
  return (
    <div>
      <DataGrid
        childrenColumnName={"groups"}
        title={`${category.name} - ${translate(
          "editors.index_type_groups.title"
        )}`}
        columns={columns}
        translate={translate}
        dataSource={indexTypeGroups.toFlatArray}
        allowCreate={true}
        allowUpdate={true}
        allowDelete={true}
        deleteModalTitle={translate("editors.index_type_groups.delete_title")}
        deleteModalMessage={translate("editors.index_type_groups.delete_modal")}
        rowClickAction={"details"}
        addButtonText={translate("editors.index_type_groups.add_new_text")}
        createForm={
          <IndexTypeGroupForm
            translate={translate}
            form={CreateForm}
            category={category}
            indexTypeGroups={indexTypeGroups}
          />
        }
        updateForm={
          <IndexTypeGroupForm
            translate={translate}
            form={UpdateForm}
            category={category}
            indexTypeGroups={indexTypeGroups}
          />
        }
        createModalTitle={`${translate(
          "editors.index_type_groups.create_modal_title"
        )}`}
        loading={referenceLoader}
        onCreate={(e) => {
          createIndexTypeGroup(e);
        }}
        onUpdate={(e) => {
          updateIndexGroupType(e);
        }}
        onDelete={(e) => deleteIndexGroupType(e)}
        booleanColumnKeys={["valid"]}
        createModalClass={"modal-width"}
        updateModalClass={"modal-width"}
        keyProperty={"id"}
        CreateFormInstance={CreateForm}
        UpdateFormInstance={UpdateForm}
        createActionPosition={"topRight"}
      />

      <CreateModal
        translate={translate}
        title={translate("editors.index_type_groups.title_item")}
        visible={createItemModalVisible}
        onCancel={() => {
          onChangeCreateItemModalVisible(false);
          CreateItemForm.resetFields();
        }}
        onCreate={createIndexType}
        Form={<IndexTypeForm translate={translate} form={CreateItemForm} />}
        formInstance={CreateItemForm}
        className={"modal-width"}
        okText={translate("data_grid.modal.actions.save")}
        cancelText={translate("data_grid.modal.actions.cancel")}
      />
      <TransferListGroupItemModal
        translate={translate}
        modalVisible={assignItemsModalVisible}
        onChangeModalVisible={onChangeAssignItemsModalVisible}
        indexTypes={indexTypes}
        currentGroupItems={currentGroupIndexTypes}
        assignItems={assignItems}
        finishAssigningItems={finishAssigningItems}
        onChangeCreateItemModalVisible={onChangeCreateItemModalVisible}
        createItem={createIndexType}
      />
      <TransferListGroupChildModal
        translate={translate}
        modalVisible={assignGroupsModalVisible}
        onChangeModalVisible={onChangeAssignGroupsModalVisible}
        indexGroups={indexTypeGroups.toFlatArray}
        currentGroupChildGroups={currentGroupChildrenGroupIds}
        assignChildGroups={assignGroups}
        finishAssigningGroups={finishAssigningGroups}
      />
    </div>
  );
};
export default IndexTypeGroupGrid;
